import { useEffect } from 'react'
import moment from 'moment'
import { Datepicker } from '../../../components/Datepicker'
import { Typography } from '../../../components/Typography'
import { CognusARTable } from './CognusARTable/CognusARTable'
import { InvoicesDetailsPopup } from './InvoicesDetailsPopup/InvoicesDetailsPopup'
import DisputeProcessCantBeDonePopup from './DisputeProcessCantBeDonePopup/DisputeProcessCantBeDonePopup'
import { FinancialsChartLegendPart } from '../FinancialsChartLegendPart/FinancialsChartLegendPart'
import { PaymentStatusChart } from '../PaymentStatusChart/PaymentStatusChart'
import { useFinancialsCognusARContext } from '../Providers/FinancialsCognusARProvider'
import { getFinancialStatusLegendOrder } from '../FinancialsChartLegendPart/constants'
import { FINANCIAL_STATUS_LABEL, REPORTS_COLORS } from '../constants'
import { timelineQuarterFormat } from '../../../components/Timelines/constants'

export const CognusAR = () => {
  const {
    state: { period, reports, totalAmount },
    actions: { setPeriod, getChartsData }
  } = useFinancialsCognusARContext()

  useEffect(() => {
    getChartsData()
    // eslint-disable-next-line
  }, [period])

  return (
    <div className="rebates column gap-24">
      <div className="rebates__date-filter">
        <Datepicker
          propsDate={{
            picker: 'quarter',
            format: timelineQuarterFormat,
            value: period,
            onChange: (date) => setPeriod(moment(date).startOf('quarter'))
          }}
          propsItem={{
            label: 'Period'
          }}
        />
      </div>
      <div className="rebates__container column gap-24">
        <Typography.Headline4>Payment Status</Typography.Headline4>
        <div className="rebates__chart-container row">
          <div className="rebates__chart">
            <PaymentStatusChart
              total={totalAmount}
              data={getFinancialStatusLegendOrder(reports)}
              needMultiply
            />
          </div>
          <div className="rebates__legend">
            {getFinancialStatusLegendOrder(reports).map((i) => (
              <FinancialsChartLegendPart
                key={i.status}
                color={REPORTS_COLORS[i.status]}
                name={FINANCIAL_STATUS_LABEL[i.status]}
                price={i.amount}
              />
            ))}
          </div>
        </div>
      </div>
      <CognusARTable />
      <InvoicesDetailsPopup />
      <DisputeProcessCantBeDonePopup />
    </div>
  )
}
